import React from "react";
import { View } from "react-native";
import Svg, { Path } from "react-native-svg";

interface AppleIconProps {
  size?: number;
}

const AppleIcon: React.FC<AppleIconProps> = ({ size = 25 }) => {
  return (
    <View style={{ width: size, height: size }}>
      <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <Path
          d="M17.5688 12.3081C17.5521 10.4207 19.109 9.5159 19.1789 9.47351C18.2979 8.1628 16.9305 7.98376 16.4554 7.96851C15.3112 7.84732 14.2011 8.65049 13.6183 8.65049C13.0234 8.65049 12.125 7.98065 11.1584 8.00098C9.91331 8.02131 8.7488 8.76063 8.10918 9.89158C6.78908 12.2182 7.77303 15.6374 9.03844 17.5164C9.67115 18.4365 10.4108 19.464 11.3788 19.4275C12.3251 19.3876 12.6789 18.8149 13.8217 18.8149C14.9535 18.8149 15.2857 19.4275 16.2722 19.4047C17.288 19.3876 17.9287 18.465 18.5398 17.5367C19.2713 16.4813 19.5654 15.4428 19.5775 15.3894C19.5532 15.3817 17.5885 14.6122 17.5688 12.3081Z"
          fill="#000000"
        />
        <Path
          d="M15.7075 6.75205C16.2177 6.10021 16.5663 5.21447 16.4692 4.31445C15.7332 4.3475 14.8121 4.82752 14.281 5.46284C13.8104 6.02153 13.3899 6.94155 13.4984 7.80713C14.3256 7.87259 15.1766 7.38495 15.7075 6.75205Z"
          fill="#000000"
        />
      </Svg>
    </View>
  );
};

export default AppleIcon;
